export enum MediaType {
  ICON = 'icon',
  IMAGE = 'image',
}
